import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
    profile: { Success: false, Data: { Count: 0 } },
    status: 'idle',
    error: null,
};

export const fetchProfile = createAsyncThunk(
    'user/fetchProfile',
    async token => {
        console.log('gateway location ', process.env.REACT_APP_API_GATEWAY);
        const response = await axios.get('/profile', {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/profile`,
            timeout: 30000,
            headers: {
                authorization: `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
        });
        return await response.data.Message;
    }
);
// need to obtain token silently before the API call and remove from availability page
export const addProfile = createAsyncThunk(
    'user/createUserProfile',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.post('/createUserProfile', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/createUserProfile`,
            timeout: 30000,
            headers: headers,
        });
        return response;
    }
);

export const updateProfile = createAsyncThunk(
    'user/updateUserProfile',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.put('/updateUserProfile', data.request, {
            baseURL: process.env.REACT_APP_API_GATEWAY,
            url: `/updateUserProfile`,
            timeout: 30000,
            headers: headers,
        });
        return await response;
    }
);

export const confirmNetwork = createAsyncThunk(
    'user/confirmNetwork',
    async data => {
        const headers = {
            authorization: 'Bearer ' + data.token,
            'Content-Type': 'application/json',
        };
        const response = await axios.post(
            '/confirmNetworkRequest',
            data.request,
            {
                baseURL: process.env.REACT_APP_API_GATEWAY,
                url: `/confirmNetworkRequest`,
                timeout: 30000,
                headers: headers,
            }
        );
        return await response;
    }
);

const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        infoAdded(state, action) {
            const {
                firstName,
                lastName,
                address,
                dateOfBirth,
                type,
                profileImage,
                lat,
                lng,
                phoneNumber,
            } = action.payload;
            const currentProfile = state.profile;
            if (currentProfile) {
                currentProfile.firstName = firstName;
                currentProfile.lastName = lastName;
                currentProfile.address = address;
                currentProfile.dateOfBirth = dateOfBirth;
                currentProfile.type = type;
                currentProfile.profileImage = profileImage;
                currentProfile.lat = lat;
                currentProfile.lng = lng;
                currentProfile.phoneNumber = phoneNumber;
            }
        },
        addVerification(state, action) {
            console.log('Teacher is verified', action);
            var interimState = state.profile.Data;

            interimState.Items[0].verified = action.payload.verified;

            state.profile.Data = interimState;
        },
    },
    extraReducers: {
        [fetchProfile.pending]: (state, action) => {
            state.status = 'loading';
        },
        [fetchProfile.fulfilled]: (state, action) => {
            // Add any fetched posts to the array
            console.log('typeof ' + JSON.stringify(action.payload));
            if (typeof action.payload !== 'undefined') {
                state.status = 'succeeded';
                console.log(
                    'this is the response ' +
                        JSON.stringify(action.payload.Data)
                );
                console.log('Count is: ' + action.payload.Data.Count);
                state.profile = action.payload;
            } else {
                state.status = 'failed';
            }
        },
        [fetchProfile.rejected]: (state, action) => {
            state.status = 'failed';
            state.error = action.payload;
        },
        [addProfile.fulfilled]: (state, action) => {
            console.log('action ' + JSON.stringify(action.payload.Data));

            state.profile = action.payload.data.Message;
        },
        [updateProfile.pending]: (state, action) => {
            state.status = 'loading';
        },
        [updateProfile.fulfilled]: (state, action) => {
            console.log('action ' + JSON.stringify(action));
            let setUpState = {
                'Success': true,
                'id': 3,
                'Code': 'User Profile Updated',
                'Data': {
                    'Count': 1,
                    'Items': [action.payload.data.Message.Data],
                },
            };
            state.status = 'succeeded';
            state.profile = setUpState;
        },
        [confirmNetwork.fulfilled]: (state, action) => {
            console.log('action ' + JSON.stringify(action.payload));
            let interimProfile = state.profile.Data;
            // const currentNetwork = interimProfile.Data.Items[0].network;

            // const outcome = action.data.Message.Data.acceptResult;
            interimProfile.Items[0].network =
                state.profile.Data.Items[0].network.map(netwrk => {
                    if (
                        netwrk.invitedBySchool ===
                        action.payload.data.Message.Data.acceptResult
                            .invitedBySchool
                    ) {
                        netwrk.status = 'accepted';
                        return netwrk;
                    } else {
                        netwrk.status = 'rejected';
                        return netwrk;
                    }
                });
            console.log(interimProfile);
            state.profile.Data = interimProfile;
            //map all the statuses back from the API call to update the screen

            //TODO: const updatedNetwork = currentNetwork.map(network => if())

            //Need to change the items on the network section of the users profile based on the acceptance or rejecting of the outcomes
        },
    },
});

export const { infoAdded, addVerification } = profileSlice.actions;

export default profileSlice.reducer;

export const getProfile = state => state.profile;
